import DoctorsApi from '../../apis/Doctors';
import CustomersApi from '../../apis/Customers'
export default {
    namespaced: true,
    state: {
        doctors: [],
        doctor_selected: {},
        person: null,
        file_name: null,
        paginated:{}
    },
    mutations: {
        set_doctors(state, doctors){
            state.doctors = doctors
        },
        set_doctor (state, doctor) {
            state.doctor_selected = doctor;
        },
        set_person (state, data) {
            state.person = data;
        },
        set_file_name (state, value) {
            state.file_name = value;
        },
        set_paginated (state, data) {
            state.paginated =  data
        }
    },
    actions: {
        setDoctor ({commit}, doctor) {
            commit('set_doctor', doctor);
        },
        setDoctors ({commit}, doctors) {
            commit('set_doctors', doctors);
        },
        async getDoctors({commit, dispatch}, filters) {
            return await DoctorsApi.get_allPaginated(filters)
                        .then( response => {
                            commit('set_paginated', {
                                ...response.data
                            })
                            commit('set_doctors', response.data.data)
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar médicos, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async store({dispatch}, doctor) {
            return await DoctorsApi.store(doctor)
                .then( response => {
                    dispatch('notifications/store_notification', {
                        type: 'success',
                        message: 'El registro se realizó de forma correcta.'
                    }, {root: true});
                    dispatch('getDoctors');
                    dispatch('sales/select_doctor', response.data, {root: true});
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    let message = 'Ocurrió un error al registrar médico, vuelva a intentarlo.';
                    if (error.response.data && error.response.data.custom_error) {
                        message = error.response.data.custom_error;
                    }
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: message
                    }, {root: true});
                })
        },
        async update({dispatch}, doctor) {
            return await DoctorsApi.update(doctor)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La actualización se realizó de forma correcta'
                                }, {root: true});
                                dispatch('getDoctors');
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al actualizar médicos, vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
        async change_status({dispatch}, doctor) {
            let action = (doctor.active) ? 'inactivación' : 'activación';
            return await DoctorsApi.change_status(doctor)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La ' + action + ' se relizó de forma correcta.'
                                }, {root: true});
                                dispatch('getDoctors')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al realizar la ' + action + ', vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
        async delete({dispatch}, doctor) {
            return await DoctorsApi.delete(doctor)
                .then( response => {
                    dispatch('notifications/store_notification', {
                        type: 'success',
                        message: 'La eliminación se realizó de forma correcta.'
                    }, {root: true});
                    dispatch('getDoctors')
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al eliminar, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        emptyPerson({commit}) {
            commit('set_person', null);
        },
        async searchDocument({commit, dispatch}, document) {
            return await CustomersApi.search_document(document)
                .then( response => {
                    console.log(response);
                    commit('set_person', response.data);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    let message = 'No se encontró número de documento';
                    if (error.response.data.error_message) {
                        message = error.response.data.error_message;
                    }
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: message
                    }, {root: true});
                })
        },
        async downloaddoctors({commit, dispatch}, filters) {
            commit('set_file_name', null);
            return await DoctorsApi.download(filters)
                .then( response => {
                    commit('set_file_name', response.data.file_name);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al descargar, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async upload({ dispatch }, doctor) {
            return await DoctorsApi.upload(doctor)
              .then((response) => {
                dispatch(
                  "notifications/store_notification",
                  {
                    type: "success",
                    message:
                      "Los doctores del archivo se registraron de forma correcta.",
                  },
                  { root: true }
                );
                dispatch('getDoctors');
            })
              .catch((error) => {
                if (error.response?.status === 401) return null
                let message =
                  "Ocurrió un error al registrar productos del archivo, vuelva a intentarlo.";
                if (error.response.data && error.response.data.message) {
                  message = error.response.data.message;
                }
                dispatch(
                  "notifications/store_notification",
                  {
                    type: "error",
                    message: message,
                  },
                  { root: true }
                );
            });
        },
    }
}